import React from 'react';
import { AnyObject } from 'final-form';
import { components } from 'react-select';

import WpIcon from 'Wpds/components/icon/WpIcon';
import Colors from 'Wpds/colors/ColorConstants';
import { GoalIcons } from 'Shared/constants/types';

const SubGoalSingleValue = (props: AnyObject) => {
  return (
    <components.SingleValue {...props}>
      <div className="SubGoalFieldOption__title d-flex align-items-center">
        <div className="mr-2">
          <WpIcon name={props.data.icon || GoalIcons.ice_cream} color={Colors.blue[500]} />
        </div>
        {props.data.label}
      </div>
    </components.SingleValue>
  );
};

export default SubGoalSingleValue;
